import { z } from "zod";

// Zod validation schema
export const createPostSchema = z.object({
  content: z.string().min(1, "Post content is required").max(5000, "Post content must be less than 5000 characters"),
  langCodes: z.array(z.string()).optional().nullable(),
  mediaFiles: z
    .array(
      z.object({
        id: z.string(),
        name: z.string(),
        size: z.number().max(10 * 1024 * 1024, "File size must be less than 10MB"),
        type: z.enum(["image", "video"]),
        file: z.instanceof(File), // File object
      })
    )
    .max(10, "Maximum 10 files allowed")
    .optional(),
  scheduledDate: z
    .string()
    .optional()
    .refine(
      (date) => {
        if (!date) return true; // Optional field, so empty is valid
        const scheduledTime = new Date(date);
        const now = new Date();
        return scheduledTime > now;
      },
      {
        message: "Scheduled date must be in the future",
      }
    )
    .refine(
      (date) => {
        if (!date) return true;
        const scheduledTime = new Date(date);
        const maxFutureDate = new Date();
        maxFutureDate.setFullYear(maxFutureDate.getFullYear() + 1); // 1 year from now
        return scheduledTime <= maxFutureDate;
      },
      {
        message: "Scheduled date cannot be more than 1 year in the future",
      }
    ),
});

export const editScheduledPostSchema = createPostSchema.partial();
